import { createApp } from 'vue';
import App from './index.vue';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'uno.css';
const app = createApp(App);
AOS.init({
  duration: 800, // 动画时长（毫秒）
  once: true, // 是否仅触发一次
  disable: 'mobile', // 在移动端禁用
});

app.mount('#app');
